import apiRequest from "@app/utils/apiRequest";

// Run job APIs
export const requestStartRunDVTJCUV = (data) => apiRequest.post(`/dvtjcuv/run-dvtjcuv/start`, data)
export const requestCheckFollowUpDVTJCUV = (data) => apiRequest.post(`/dvtjcuv/run-dvtjcuv/check-follow-up`, data)
export const requestAddCddToFollowUpTabDVTJCUV = (data) => apiRequest.post(`/dvtjcuv/run-dvtjcuv/add-cdd-follow-up-tab`, data)

export const requestSearchCddJobOverview = (data) => apiRequest.get(`/dvtjcuv/run-dvtjcuv/search-cdd-job/overview`, data)

// request get receiver summary
export const requestGetReceiverSummary = (data) => apiRequest.get(`/dvtjcuv/run-dvtjcuv/receiver/summary`, data)

export const requestGetCddJobNote = (cddId) => apiRequest.get(`/dvtjcuv/run-dvtjcuv/search-cdd-job/notes`, {params: {cdd_id: cddId}})
export const requestSaveCddJobNote = (data) => apiRequest.post(`/dvtjcuv/run-dvtjcuv/search-cdd-job/notes`, data)
// export const requestMoveCddDVTJCUVToTab = (data) => apiRequest.post(`/dvtjcuv/run-dvtjcuv/move-candidates-to-tab`, data)

export const requestGetEmployerSummary = (employerId) => apiRequest.get(`/dvtjcuv/run-dvtjcuv/search-employer/summary`, {params: {employer_id: employerId}})

export const requestInputEmailInviteDVTJCUV = (data) => apiRequest.post(`dvtjcuv/run-dvtjcuv/input-email-invite`, data)

export const requestSaveEmailInviteTempDataDVTJCUV = (data) => apiRequest.post(`dvtjcuv/run-dvtjcuv/input-email-invite-temp-data`, data)
export const requestMoveCddDVTJCUVToTab = (data) => apiRequest.post(`dvtjcuv/run-dvtjcuv/move-candidates-to-tab`, data)

export const requestGetEmailInviteTempDataDVTJCUV = (candidateId, parentTab) => apiRequest.get(`/dvtjcuv/run-dvtjcuv/input-email-invite-temp-data`, {params: {candidate_id: candidateId, parent_tab: parentTab}})

export const requestRemoveCandidatesOutDVTJCUVTabs = (data) => apiRequest.post(`dvtjcuv/run-dvtjcuv/remove-candidates-out-dvtjcuv-tabs`, data)

export const requestCheckBriefEmailCondition = (data) => apiRequest.post(`dvtjcuv/run-dvtjcuv/check-brief-email-conditions`, data)

export const requestInputBriefEmailDVTJCUV = (data) => apiRequest.post(`dvtjcuv/run-dvtjcuv/input-email-brief`, data)
